import Vue from 'vue'
import Vuex from 'vuex'
import ClassroomModule from '@/core/storage/classroom'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ClassroomModule: ClassroomModule
  }
})
